<template>
  <mp-error v-if="isError === true"></mp-error>
  <div
    id="mp-createjs"
    v-else
    class="game-container"
    :style="[getCustomStyle(startGameConfig), startGameConfig.customStyle]"
  >
    <img v-if="withClose" draggable="true" class="exit-icon controll-icon" @click="closeModal()" :src="exitIcon" />
    <div id="mainImage" class="main-image-container" :style="getImageStyle(imageData)"></div>
    <mp-paint
      v-if="typeof startGameConfig.paint !== 'undefined' && startGameConfig.paint != null"
      :start-game-config="startGameConfig.paint"
      :panel="panelDraw"
      @changeConfig="onUpdatePaint"
      style="width: 1920px"
    >
    </mp-paint>
    <div id="game-container" :style="getCustomStyle(startGameConfig.canvas)">
      <div id="cjsTxts" class="main-txt-container"></div>

      <canvas id="gameCanvas" @mousedown="resetStatus"></canvas>
    </div>
    <div v-for="item in getVueComponents()" :key="`${item}`">
      <component
        :is="componentEngine(`${item}`)"
        :start-game-config="gameConfig(`${item}`)"
        :item-data="gameConfig(`${item}`)[0]"
        :ref="'check' + `${item}`"
      ></component>
    </div>
    <span v-if="cjsStage != null">
      <mz-mask-in-game
        :key="'mz-mask-' + index"
        v-for="(data, index) in cjsStage.config.staticMaskConfig"
        :item-data="data"
        :mask-data="maskData"
        @change-item-mask="changeItemMask"
      ></mz-mask-in-game>
      <mb-audio-in-game
        :key="data.top + data.left + 'audio' + index"
        v-for="(data, index) in cjsStage.config.mbAudioItemData"
        :item-data="data"
        :id="data.id"
        :mask-data="maskData"
        @change-item-mask="changeItemMask"
      ></mb-audio-in-game>
    </span>
    <span v-if="cjsStage != null">
      <tr-static-text
        :id="item.id"
        :static-text="item"
        class="text-element disable-mouse"
        v-for="(item, index) in cjsStage.config.katexData"
        :key="'static-text_' + index"
        :style="getStaticTextStyle(item)"
      >
      </tr-static-text>
    </span>
    <span v-if="cjsStage != null">
      <tr-static-text
        :static-text="item"
        class="text-element"
        v-for="(item, index) in cjsStage.config.staticText"
        :key="'static-text_' + index"
        :style="getStaticTextStyle(item)"
      >
      </tr-static-text>
    </span>
    <div
      v-if="showPlayer"
      :class="{ 'modal-ui-active': modalActive }"
      class="audio"
      :style="audioPlayerStyle(startGameConfig.audioPlayer)"
    >
      <audio
        id="playerAudio"
        controlsList="nodownload noplaybackrate"
        :style="`--plyr-color-main: ${playerColor}`"
        controls
        crossorigin
        playsinline
      >
        <source :src="giveMeAudio(audioFile)" type="audio/ogg" />
        <source :src="giveMeAudio(audioFile)" type="audio/mpeg" :key="componentKey" />
        Your browser does not support the audio element.
      </audio>
    </div>
    <!-- <div v-if="showTitle" class="title-test">{{ this.$store.getters.gameData.centerBar }}</div> -->
  </div>
</template>

<script>
/**
 *      MOTTO DNIA: Niech wam wystarczy wierzyć, że tak jest,
 *                  a nie dociekać, dlaczego jest
 */

window.ontouchstart = null;

import _ from 'lodash';
import * as $ from 'jquery';
import 'bootstrap';
import 'bootstrap-colorpicker';

import createjs from 'createjs-collection';
import defaultMixins from '../../mixins/defaultMixin';
import createjsMixin from '../../mixins/createjsMixin';
import * as fJS from '../../mixins/cjsRoot/fJS';
import { cjsStage } from '../../mixins/cjsStage';

import { getGamePath } from './../../Utils/pathUtils.js';

import mpPaint from './components/MpPaint';
import mpError from '../MpError/MpError';
import TrInputOnBackground from '../InputOnBackground/TrInputOnBackground';
import TrStaticText from '../TrInput/TrStaticText';
import * as utils from '../../Utils/inputUtils';
import MpModelShow from '../MpModel3d/MpModel3d';
import mzMaskInGame from '__mainSrcDir/components/MzMask/MzMaskInGame';
import mbAudioInGame from '__mainSrcDir/components/MbAudioModal/MbAudioInGame';

import STORE from '@/store';
import { PanelDraw } from './js/panelDraw';

// importy do audio bar'a
import Plyr from 'plyr';

export default {
  name: 'mp-createjs',
  mixins: [defaultMixins, createjsMixin],
  components: { mpError, TrInputOnBackground, TrStaticText, mzMaskInGame, mbAudioInGame, MpModelShow, mpPaint },
  props: {
    startGameConfig: {
      type: Object,
      default: function () {
        return {};
      },
    },
    withClose: {
      type: Boolean,
      default: function () {
        return false;
      },
    },
  },
  data() {
    return {
      maskData: [],
      /** @param {object} obiekt zawierający dane tła kanwy */
      imageData: null,
      /** @param {cjsStage} obiekt klasy cjsStage */
      cjsStage: null,
      isError: false,
      stopWatch: null,
      panelDraw: {},
      //poniżej data do audio bar'a
      showPlayer: false,
      player: {},
      destroyAudio: false,
      componentKey: true,
      audioFile: '',
      playerColor: '#00b3ff',
    };
  },
  beforeMount() {
    this.prototypeArray();
    this.imageData = this.startGameConfig.mainImage;
    this.stopWatch = new fJS.Stopwatch();
    if (typeof this.startGameConfig.paint !== 'undefined' && this.startGameConfig.paint != null) {
      this.panelDraw = new PanelDraw(this.startGameConfig.paint);
    }
  },
  mounted() {
    try {
      this.stopWatch.start();
      //    cjsStage.prototype.runLoad(stage);
      if (this.startGameConfig.fullscreen !== true && !this.startGameConfig.customStyle) {
        document.getElementsByClassName('game-container')[0].style.padding = '160px 50px 100px';
      }
      this.$store.commit('CHANGE_CHECK_CJS', false);
      if (this.cjsStage != null) this.cjsStage.beforeDestroy();
      this.cjsStage = new cjsStage(this.startGameConfig, {
        getDefaultFont: this.$store.getters.getDefaultFont,
        multibookType: this.$store.getters.multibookType,
      });
      if (this.cjsStage != null) {
        var self = this;
        Promise.all(this.cjsStage._fonts)
          .catch((err) => {
            console.log(err);
          })
          .finally(() => {
            self.cjsStage.initGame();
            self.$forceUpdate();
            // self.cjsStage.stage.on('mousedown', self.stageMouseDown);
            self.cjsStage.runFunctionEngine('afterLoadSamples');
            self.cjsStage.runFunctionEngine('defineKeys');
            self.runPromises();
            if (typeof self.startGameConfig.paint !== 'undefined' && self.startGameConfig.paint != null) {
              self.onUpdatePaint({ panel: self.panelDraw });
            }
            // this.stopWatch.stop();
            if (process.env.NODE_ENV === 'development') {
              console.log('loading: ' + this.stopWatch.render() + ' s.');
            }
          });
      }
      const controls = ['play', 'restart', 'progress', 'current-time', 'mute', 'volume', 'settings'];
      this.player = new Plyr('#playerAudio', { controls });

      if (this.startGameConfig.showPlayer) this.showPlayer = true;
      if (this.startGameConfig.audioSrc) this.audioFile = this.startGameConfig.audioSrc;
      if (this.startGameConfig.mbAudioItemData) {
        this.maskData = this.startGameConfig.mbAudioItemData
          .filter((d) => d.hasOwnProperty('maskConfig'))
          .map(({ id }) => ({ id: id, isWrapped: true }));
        if (this.maskData.length > 0) this.$store.commit('LOCK_GAME', true);
      }
      if (this.startGameConfig.staticMaskConfig) {
        this.maskData = this.startGameConfig.staticMaskConfig.map(({ id }) => ({ id: id, isWrapped: true }));
        if (this.maskData.length > 0) this.$store.commit('LOCK_GAME', true);
      }
    } catch (e) {
      document.getElementById('mainImage').style.display = 'none';
      document.getElementById('cjsTxts').style.display = 'none';
      this.isError = true;
      this.stopWatch.stop();

      if (this.cjsStage != null) this.cjsStage.beforeDestroy();
      delete this.cjsStage;
      if (process.env.NODE_ENV === 'development') {
        console.log(e);
        console.log('GAME F*** SHUTDOWN\nand have a nice day!');
      }
    }
  },
  methods: {
    changeItemMask(value) {
      if (this.maskData.length > 0) {
        this.maskData = value.item;
        this.checkIfLocked();
      }
    },
    checkIfLocked() {
      if (this.maskData.length > 0) {
        if (this.maskData.filter((el) => el.isWrapped === true).length < this.maskData.length) {
          this.$store.commit('LOCK_GAME', false);
        } else {
          this.$store.commit('LOCK_GAME', true);
        }
      }
    },
    closeModal() {
      if (this.cjsStage != null) this.cjsStage.beforeDestroy();
      this.$emit('closeCreateJS');
    },

    onUpdatePaint(param) {
      this.panelDraw = param.panel;
      let item = false;

      for (let gr in this.cjsStage.groups) {
        for (let id in this.cjsStage.groups[gr].items) {
          if (this.cjsStage.groups[gr].items[id].block === true) continue;
          item = this.cjsStage.groups[gr].items[id];
          item.active = true;
          break;
        }
      }
      for (let i = 0; i < this.panelDraw.colors.length; i++) {
        if (this.panelDraw.colors[i].active === true) {
          item.changeColor(this.panelDraw.colors[i].val);
        }

        item.erase = this.panelDraw.erase;
        item.panel = this.panelDraw;
        if (item.active === true) {
          item.point.size = this.panelDraw.size;
        }
      }
    },

    giveMeImagePlease(p) {
      let path = require('path');
      let imgPath = p;
      imgPath = imgPath.replace('static/', '');
      imgPath = path.normalize(imgPath);
      return imgPath;
    },

    objectImageExist(item) {
      return _.isObject(item) && !_.isNil(item.imagePath);
    },

    runPromises() {
      if (this.cjsStage.promises.length === 0) {
        for (let gr in this.cjsStage.groups) {
          for (let i in this.cjsStage.groups[gr].items) {
            this.cjsStage.cacheItem(this.cjsStage.groups[gr].items[i]);
          }

          this.cjsStage.cacheItem(this.cjsStage.groups[gr]);
        }

        this.cjsStage.update();
        this.cjsStage.runFunctionEngine('afterPromises');
        this.stopWatch.stop();
        if (process.env.NODE_ENV === 'development') {
          console.log('Loaded: ' + this.stopWatch.render() + ' s.');
        }
        return;
      }
      let self = this;
      Promise.all(this.cjsStage.promises)
        .then((resp) => {
          let exluded = [];
          for (let i = 0; i < resp.length; i++) {
            if (resp[i].isClone === true) {
              continue;
            }

            self.cjsStage.cacheItem(resp[i]);
          }
        })
        .then(() => {
          self.cjsStage.update();
          self.cjsStage.runFunctionEngine('afterPromises');
          self.stopWatch.stop();
          if (process.env.NODE_ENV === 'development') {
            console.log('Loaded: ' + self.stopWatch.render() + ' s.');
          }
        })
        .catch((err) => {
          document.getElementById('mainImage').style.display = 'none';
          document.getElementById('cjsTxts').style.display = 'none';
          self.isError = true;
          this.stopWatch.stop();

          if (self.cjsStage != null) self.cjsStage.beforeDestroy();
          delete self.cjsStage;
          if (process.env.NODE_ENV === 'development') {
            console.log(err);
            console.log('GAME F*** SHUTDOWN\nand have a nice day!');
          }
        });
    },

    getImageStyle(imageData) {
      if (_.isObject(imageData) && imageData.imagePath) {
        if (!imageData.pos) {
          imageData = Object.assign({}, imageData, {
            pos: {
              x: 0,
              y: 0,
            },
          });
        }
        if (!imageData.height) {
          imageData = Object.assign({}, imageData, {
            height: 1080,
          });
        }
        if (!imageData.width) {
          imageData = Object.assign({}, imageData, {
            width: 1920,
          });
        }
      } else {
        return 'display : none;';
      }

      let imagePath = getGamePath(imageData.imagePath);
      let image = require(`__staticDir/${this.$store.getters.multibookType}/${imagePath}`);
      return _.merge({ position: 'absolute', left: '0' }, this.getCustomStyle(imageData), {
        'background-image': `url(${image})`,
        top: fJS.isNumeric(imageData.pos.y)
          ? imageData.pos.y + 'px'
          : fJS.isNumeric(imageData.offsetVertical)
          ? imageData.offsetVertical
          : 0,
        left: fJS.isNumeric(imageData.pos.x)
          ? imageData.pos.x + 'px'
          : fJS.isNumeric(imageData.offsetHorizontal)
          ? imageData.offsetHorizontal
          : 0,
        width: fJS.isNumeric(imageData.width) ? imageData.width + 'px' : '100%',
        height: fJS.isNumeric(imageData.height) ? imageData.height + 'px' : '100%',
      });
    },

    getCustomStyle(item) {
      let customStyle = {};
      if (item && item.cssStyle) {
        if (_.isObject(item.cssStyle)) {
          customStyle = _.mapKeys(item.cssStyle, function (value, key) {
            return _.toString(key);
          });
        }
      }
      return customStyle;
    },

    checkGameAction() {
      let correct = true;
      for (const key in this.$refs) {
        correct = this.$refs[key][0].checkGameAction() !== true ? false : correct;
      }

      let result = this.cjsStage.checkGameAction();

      // this.$nextTick(function() {
      //   this.$store.commit('CHANGE_CHECK_CJS', true);
      //   this.$forceUpdate();
      // });

      return result && correct;
    },

    resetGameAction() {
      if (this.maskData.length > 0) for (let m of this.maskData) m.isWrapped = true;
      this.checkIfLocked();
      this.stopWatch.reset();
      this.resetStatus();

      if (
        typeof this.cjsStage.config.katexData !== 'undefined' &&
        Array.isArray(this.cjsStage.config.katexData) === true
      ) {
        this.cjsStage.config.katexData.splice(0, this.cjsStage.config.katexData.length);
      }

      // this.$forceUpdate();

      for (const key in this.$refs) {
        this.$refs[key][0].resetGameAction();
      }

      this.cjsStage.resetGameAction();
      this.cjsStage.runFunctionEngine('afterLoadSamples');
      this.cjsStage.runFunctionEngine('defineKeys');
      this.runPromises();
      if (typeof this.startGameConfig.paint !== 'undefined' && this.startGameConfig.paint != null) {
        this.onUpdatePaint({ panel: this.panelDraw });
      }
    },

    getVueComponents() {
      if (typeof this.startGameConfig.vue !== 'object' || this.startGameConfig.vue === null) {
        return [];
      }
      return Object.keys(this.startGameConfig.vue);
    },

    componentEngine(name) {
      return `${name}`;
    },

    gameConfig(name) {
      if (
        typeof this.startGameConfig.vue !== 'object' ||
        this.startGameConfig.vue === null ||
        typeof this.startGameConfig.vue[name] !== 'object' ||
        this.startGameConfig.vue[name] === null
      )
        throw 'Brak konfiguracji dla komponentu: ' + name;

      return _.cloneDeep(this.startGameConfig.vue[name]);
    },

    resetStatus() {
      this.$store.commit('CHANGE_CHECK_SWITCH', false);
      this.$store.commit('CHANGE_CHECK_CJS', false);
      this.$store.dispatch('resetCheckStatus');
      /** @type {Boolean}  return true becouse want to event to propagate  */
      return true;
    },
    getStaticTextStyle(staticTextElement) {
      staticTextElement.offsetVertical = staticTextElement.offsetVertical
        ? staticTextElement.offsetVertical
        : this.startGameConfig.staticTextElementOffsetVertical;
      staticTextElement.offsetHorizontal = staticTextElement.offsetHorizontal
        ? staticTextElement.offsetHorizontal
        : this.startGameConfig.staticTextElementOffsetHorizontal;
      staticTextElement.width = staticTextElement.width
        ? staticTextElement.width
        : this.startGameConfig.staticTextElementWidth;
      staticTextElement.height = staticTextElement.height
        ? staticTextElement.height
        : this.startGameConfig.staticTextElementHeight;
      return _.merge({ position: 'absolute' }, this.getCustomStyle(staticTextElement), {
        // 'position': 'absolute',
        top: utils.elementTopPosition(staticTextElement.pos.y, staticTextElement.offsetVertical),
        left: utils.elementLeftPosition(staticTextElement.pos.x, staticTextElement.offsetHorizontal),
        width: utils.elementWidth(staticTextElement.width),
        height: utils.elementHeight(staticTextElement.height),
      });
    },
    audioPlayerStyle(item) {
      if (item) {
        return this.getCustomStyle(item);
      }
      return {};
    },
    giveMeAudio(audioFile) {
      return require(`__staticDir/${this.$store.getters.multibookType}/${audioFile}`);
    },
  },
  beforeDestroy() {
    this.$store.commit('LOCK_GAME', false);
    this.resetStatus();
    // console.log('Destroy Plyr audio');
    this.destroyAudio = true;

    if (this.cjsStage != null) this.cjsStage.beforeDestroy();
  },

  watch: {},
  computed: {
    exitIcon() {
      try {
        return require(`__mainSrcDir/assets/icons/grid/gameInterface/exit-64px.png`);
      } catch {
        if (process.env.NODE_ENV === 'development') {
          console.log(
            '%cExitIcon MpCreateJS- error',
            'font-weight: bold; background: red; color: white; padding: 0px 10px'
          );
        }
      }
      return null;
    },
    modalActive() {
      return this.$store.getters.modalActive;
    },
  },
};
</script>
<style lang="sass" scoped>
.game-container
  display: flex
  flex-direction: column
  justify-content: center
  align-items: center
  width: 100% !important
  height: 100% !important
  position: absolute
  position: inherit

.disable-mouse
  pointer-events: none

.game-input-on-background-wrapper
  display: contents

#game-container
  width: 100%
  height: 100%
  z-index: 1
  position: relative

.main-image-container,
.main-txt-container
  display: block
  width: 100%
  height: 100%

  background-size: contain
  background-repeat: no-repeat

.main-txt-container
  top: 0
  left: 0
  z-index: 0
  position: static

  border-style: solid
  display: none

canvas
  z-index: 10
  position: absolute
  top: 0
  left: 0

.controll-icon
  width: 64px
  height: 64px
  top: calc(64px/3 + 64px/4)
  position: absolute
  right: calc(64px/3 + 64px/4)
  transition: .5s
  transform: scale(.9)
  cursor: pointer
  z-index: 10
  &:hover
  transform: scale(1)
  .exit-icon
    animation: 1s .3s iconShow 1 linear backwards

.audio
  z-index: 1;
  display: block;
  width: 60%;
  height: auto;
  // position: relative;
  #playerAudio
    width: 100%;
.plyr--audio .plyr__controls
  background: #e6e6e6 !important;

.plyr__menu__container
  background: rgba(#e6e6e6, 0.9);
@keyframes iconShow
  0%
    opacity: 0
    transform: rotate(-25deg) scale(.9)
  50%
    opacity: 1
    transform: rotate(-25deg) scale(.9)
  100%
    opacity: 1
</style>
